export default "__VITE_ASSET__CG7xkzBn__"